import { render, staticRenderFns } from "./CategoryProportionTable.vue?vue&type=template&id=6d6a55ad&scoped=true"
import script from "./CategoryProportionTable.vue?vue&type=script&lang=ts"
export * from "./CategoryProportionTable.vue?vue&type=script&lang=ts"
import style0 from "./CategoryProportionTable.vue?vue&type=style&index=0&id=6d6a55ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a55ad",
  null
  
)

export default component.exports